// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeMessageRequestListBody = {
  cursor?: string | null;
  limit?: number | null;
};

export type typeMessageRequestListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    items: {
      chatId: string;
      fromUserId: string;
      fromDisplayName: string;
      fromAvatarUrl?: string | null;
      firstMessagePreview: string;
      requestedAtIso: string;
      sharedPoolName?: string | null;
    }[];
    nextCursor?: string | null;
  };
};

export type typeMessageRequestListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMessageRequestListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMessageRequestListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaMessageRequestListBody = {
  type: "object",
  properties: {
    cursor: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    limit: { oneOf: [{ type: "integer" }, { enum: [null] }] },
  },
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createMessageRequestList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaMessageRequestListBody);
  }

  return async function postMessageRequestList(
    payload: typeMessageRequestListBody,
  ): Promise<
    typeMessageRequestListOutput200 | typeMessageRequestListOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postMessageRequestList" failed before calling the network. #7e4f5c7444ec`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#7e4f5c7444ec" },
        },
        data: null,
      } as typeMessageRequestListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/message-request/list`,
      httpMethod: "POST",
      options,
    })) as typeMessageRequestListOutput200 | typeMessageRequestListOutput400;
  };
}
